













import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import { RootStore } from '@/store';
import { CompanyStore } from '@/store/company';
import { LocationStore } from '@/store/location';

@Component
export default class StandardLayoutLocationSelect extends Vue {

  @LocationStore.Bind.State locationId!: LocationStore.State<'locationId'>;
  @CompanyStore.Bind.State locations!: CompanyStore.State<'locations'>;
  @Action setLocation!: RootStore.Action<'setLocation'>;

}
